import React from 'react';
import './App.css';

// Import React Components
import MaintenanceScreen from './MaintenanceScreen';
import EventsScreen from './EventsScreen';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      currentScreen: "Maintenance",
    }
  }

  changeScreen = (newScreen) => {
    this.setState({
      currentScreen: newScreen,
    });
  }

  redirect() {
    window.location.replace("http://dreamkitapp.com/updates");
  }

  renderCurrentScreen = () => {
    switch (this.state.currentScreen) {
      case "Maintenance":
        this.redirect();
        return <MaintenanceScreen />;
      case "Events":
        return <EventsScreen changeScreen={this.changeScreen} />;
      default:
        break;
    }
  }

  render() {
    return (
      <div className="App">
        {this.renderCurrentScreen()}
      </div>
    );
  }
}

export default App;